import moment from "moment";

export function createProviderSchedulesState() {
  return {
    moment,
    allScheduleList: [],
    scheduleList: [],
    attributes: [],
    date: moment().format("YYYY-MM-DD"),
    showMemoModal: false,
    memoText: "",
    memoScheduleId: "",
    showRescheduleDialog: false,
    rescheduleSchedule: null,
    showRingPickupDialog: false,
    ringPickupSchedule: null,
    savingRingPickupDate: false,
    showOfflineReservationDialog: false,
    offlineReservationDate: "",
    offlineReservationTime: "",
    offlineReservationMemo: "",
    offlineAvailableSlots: [],
    loadingOfflineSlots: false,
    savingOfflineReservation: false,
    offlineDatePickerOptions: {
      disabledDate(value) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return value.getTime() < today.getTime();
      },
    },
  };
}
